import {locale} from '#lit/common/locale/index.js';
import {governanceRulesLanguage} from '#locale/translations/governance_rules.js';

import type {NavigationConfig} from '../types.js';

export const navigationConfig: NavigationConfig = {
  sections: [
    {
      label: 'Platform',
      key: 'platform',
      items: [
        {
          label: 'Home',
          icon: 'cottage',
          path: '/home',
          policy: {entity: 'audience', action: 'index'},
        },
        {
          label: 'Audiences',
          icon: 'dashboard',
          path: '/audiences',
          policy: {entity: 'audience', action: 'index'},
        },
        {
          label: 'Journeys',
          icon: 'route',
          path: '/v2/journeys',
          policy: {entity: 'journey', action: 'index'},
        },
        {
          label: 'Syncs',
          icon: 'onlinePredicton',
          path: '/signal_routes',
          policy: {entity: 'signal_route', action: 'index'},
        },
        {
          label: 'Studio',
          icon: 'palette',
          path: '/v2/studio',
          policy: {entity: 'audience', action: 'create'},
          featureFlag: 'showAIStudio',
        },
        {
          label: 'Content',
          icon: 'photoLibrary',
          path: '/content-library',
          policy: {entity: 'content', action: 'index'},
        },
        {
          label: 'Destinations',
          icon: 'explore',
          path: '/destination_platforms',
          policy: {entity: 'destination_connection', action: 'index'},
        },
      ],
    },
    {
      label: 'Analytics',
      key: 'analytics',
      items: [
        {
          label: 'Activity',
          icon: 'queryStats',
          path: '/v2/export_activities',
          policy: {entity: 'export_activity', action: 'index'},
        },
        {
          label: 'Causal Graph',
          icon: 'schema',
          path: '/v2/context-graph-explorer',
          policy: {entity: 'audience', action: 'index'},
          featureFlag: 'contextGraphExplorer',
        },
        {
          label: 'Insights',
          icon: 'equalizer',
          path: '/insights',
        },
        {
          label: 'Metrics',
          icon: 'candlestickChart',
          path: '/metrics',
        },
        {
          label: 'Ad effectiveness',
          icon: 'queryStats',
          path: '/ad-effectiveness',
          featureFlag: 'adEffectiveness',
        },
      ],
    },
    {
      label: 'Configuration',
      key: 'data_configuration',
      items: [
        {
          label: 'Datasets',
          icon: 'storage',
          path: '/source_connections',
          policy: {entity: 'source_connection', action: 'index'},
        },
        {
          label: 'Models',
          icon: 'schema',
          path: '/models',
          policy: {entity: 'flywheel_model', action: 'index'},
          disabledByOrganizationSetting: 'disable_models',
        },
        {
          label: 'Ingest',
          icon: 'syncAlt',
          path: '/import_sources',
          policy: {entity: 'import_source', action: 'index'},
        },
        {
          label: 'Identity',
          icon: 'person',
          path: '/identities',
          policy: {entity: 'identity', action: 'index'},
        },
        {
          label: 'Channels',
          icon: 'mail',
          path: '/channels',
          policy: {entity: 'channel', action: 'create'},
        },
        {
          label: governanceRulesLanguage[locale.current].pageTitle,
          icon: 'grading',
          path: '/governance',
          policy: {entity: 'governance_rule', action: 'index'},
          featureFlag: 'governanceRules',
        },
      ],
    },
    {
      label: 'Admin',
      key: 'admin',
      items: [
        {
          label: 'Review',
          icon: 'grading',
          path: '/v2/review_audiences',
          policy: {entity: 'review_audience', action: 'index'},
        },
      ],
    },
  ],
};
